import React from 'react';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SignedOut, SignIn, useUser, SignedIn } from '@clerk/clerk-react';
import { LinkButton } from 'molecules';
import getCssVariable from 'utils/getCssVariable';
import AuthLayout from './AuthLayout';

export const Auth = () => {
  const { push } = useHistory();
  const { pathname } = useLocation();
  const { isSignedIn } = useUser();
  const { t } = useTranslation();
  const from = `/${t('roadmap')}`;

  const isRegistrationLinkVisible = !pathname.startsWith('/auth/login/factor-one');
  const [clerkThemeVariables, setClerkThemeVariables] = React.useState(undefined);

  const setVariables = () => {
    const colorPrimary = getCssVariable('--color-primary');
    const colorDanger = getCssVariable('--color-red');
    const colorWarning = getCssVariable('--color-orange');
    const colorSuccess = getCssVariable('--color-green');
    const colorText = getCssVariable('--font-color-primary');
    const fontFamily = getCssVariable('--font-primary');

    setClerkThemeVariables({
      colorPrimary,
      colorDanger,
      colorWarning,
      colorSuccess,
      colorText,
      fontFamily,
    });
  };

  React.useEffect(() => {
    if (isSignedIn) {
      push(from);
    }

    if (document.readyState !== 'loading') {
      setVariables();
    } else {
      document.addEventListener('DOMContentLoaded', setVariables);
    }
    return () => document.removeEventListener('DOMContentLoaded', setVariables);
  }, []);

  return (
    <AuthLayout>
      <SignedOut>
        <SignIn
          path="/auth/login"
          appearance={{
            elements: {
              rootBox: {
                margin: '0 auto',
              },
            },
            variables: clerkThemeVariables,
          }}
        />
        {isRegistrationLinkVisible && (
          <LinkButton primary to="/auth/register">
            {t('register')}
          </LinkButton>
        )}
      </SignedOut>
      <SignedIn>
        <Redirect to={from} />
      </SignedIn>
    </AuthLayout>
  );
};

export default Auth;
